<template>
  <div>
    <div class="w3-row w3-small w3-margin-bottom w3-border-bottom w3-border-top" style="padding: 8px 0 14px" v-show="visivel">
      <!--<div class="w3-col m1 campo-pesquisa">-->
        <!--<label for="qtdProduto"><b>Quantidade</b></label>-->
        <!--<input type="number" id="qtdProduto" v-model="qtdProduto" class="w3-input w3-border" placeholder="Qtd" :disabled="!comanda || parseInt(comanda.status) !== 1" min="0">-->
      <!--</div>-->
      <div class="w3-col m10 campo-pesquisa">
        <label for="inputCodigoProduto"><b>Pesquisar produto</b></label>
        <input type="text" id="inputCodigoProduto"
               v-model="produto" class="w3-input w3-border"
               @keyup.enter="$emit('pesquisarProduto', produto, qtdProduto)"
               autocomplete="new-address-number" placeholder="Codigo, nome, referencia, categoria..." :disabled="!comanda || parseInt(comanda.status) !== 1">
      </div>
      <div class="w3-col m2 campo-pesquisa">
        <label><b>&nbsp;</b></label>
        <button class="w3-button primary w3-block w3-round" @click="$emit('pesquisarProduto', produto, qtdProduto)" :disabled="!comanda || parseInt(comanda.status) !== 1">
          <i class="fa fa-cart-plus fa-fw icon-pdv"></i> - <b>ADICIONAR</b>
        </button>
      </div>
    </div>

    <pesquisar-produto @atualizarPedidos="inserirProduto"/>

  </div>
</template>

<script>
  import PesquisarProduto from "./PesquisarProduto"

  export default {
    name: "BuscaPDV",
    components: {PesquisarProduto},
    props: ['comanda','visivel'],
    data() {
        return {
          token: localStorage.getItem('key'),
          produto: '',
          qtdProduto: 1,
        }
    },

    methods: {
      inserirProduto(p) {
        let transacao = {
          transacao: {
            id_transacao: this.comanda.id_transacao
          }
        };

        openLoading("Inserindo as informações");
        let base = "transacoes/produto/" + this.token;
        Object.assign(p, transacao);

        // console.log(p);
        // return;
        this.$http.post(base_url + base, p, {emulateJSON: true})
          .then(res => {
            closeLoading();
            this.produto = '';
            this.qtdProduto = 1;
            this.$emit('atualizarComanda');

            if (!isMobile()) {
              focarElement('inputCodigoProduto');
            }

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result, res.data.msg);
          });
      }

    },

    created() {
      this.$parent.$on('pesquisar', () => {
        this.$emit('pesquisarProduto', this.produto, this.qtdProduto)
      });

      this.$parent.$on('pesquisaRapida', (produto) => {
        this.$emit('pesquisarProduto', produto, this.qtdProduto)
      });
    },

    mounted() {
      if (!isMobile()) {
        focarElement('inputCodigoProduto');
      }
    }
  }
</script>

<style scoped>
  .campo-pesquisa{
    margin-top: 8px;
    padding-right: 8px;
  }
  .icon-pdv {
    font-size: 16px;
  }

  @media all and (max-width: 993px) {
    .campo-pesquisa {
      padding-right: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/pdv/BuscaPDV.vue